import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class NotificationService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    get(userId) {
        return Vue.axios.get(`${APIHOST}/api/message/${userId}`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }



    getAll() {
        return Vue.axios.get(`${APIHOST}/api/message`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getAccounts() {
        return Vue.axios.get(`${APIHOST}/api/message/accounts`, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    postMessage(data) {
        return Vue.axios.post(`${APIHOST}/api/message`, data, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        });
    }
}

export default new NotificationService()